var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "root", attrs: { "max-width": "600" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("common.documents")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      !_vm.hasModule
        ? _c(
            "w-card-content",
            [
              _c("app-missing-module", {
                attrs: { "module-id": _vm.moduleId },
              }),
            ],
            1
          )
        : _vm.allFiles.length > 0
        ? [
            _c(
              "w-sortable",
              {
                attrs: {
                  tag: "w-list",
                  items: _vm.allFiles,
                  "target-class": "handle",
                },
                on: {
                  drop: function ($event) {
                    return _vm.onSort()
                  },
                },
              },
              _vm._l(_vm.allFiles, function (item, index) {
                return _c(
                  "w-list-item",
                  { key: item.uid, attrs: { "show-handle": "" } },
                  [
                    _c(
                      "w-list-item-icon",
                      [_c("w-fa", { attrs: { icon: ["far", "file"] } })],
                      1
                    ),
                    _c("w-list-item-text", [
                      _vm._v(_vm._s(_vm.getDocName(item))),
                    ]),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("edit-options"),
                                expression: "$ct('edit-options')",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                _vm.openedSettingsItem = item
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "cog" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("common.download"),
                                expression: "$ct('common.download')",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.download(item)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "download" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("common.preview"),
                                expression: "$ct('common.preview')",
                              },
                            ],
                            attrs: { disabled: !_vm.canPreviewFile(item) },
                            on: {
                              click: function ($event) {
                                return _vm.previewFile(item)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "eye" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("common.delete"),
                                expression: "$ct('common.delete')",
                              },
                            ],
                            staticClass: "danger",
                            on: {
                              click: function ($event) {
                                return _vm.removeFile(index)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              1
            ),
            _c(
              "w-card-content",
              [
                _c("app-file-upload", {
                  attrs: {
                    label: _vm.$ct("drop-your-images"),
                    sending: _vm.sending,
                  },
                  on: {
                    input: function ($event) {
                      return _vm.onFile($event)
                    },
                  },
                }),
              ],
              1
            ),
          ]
        : _c(
            "w-card-content",
            { staticClass: "list-empty-root" },
            [
              _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12", center: "" } }, [
                    _vm._v(" " + _vm._s(_vm.$ct("empty-list")) + " "),
                  ]),
                ],
                1
              ),
              _c("app-file-upload", {
                attrs: {
                  label: _vm.$ct("drop-your-images"),
                  sending: _vm.sending,
                },
                on: {
                  input: function ($event) {
                    return _vm.onFile($event)
                  },
                },
              }),
            ],
            1
          ),
      _vm.openedSettingsItem
        ? _c(
            "w-modal",
            { attrs: { value: _vm.openedSettingsItem != null } },
            [
              _c("app-sale-edit-aws-documents-options-modal", {
                attrs: {
                  sale: _vm.sale,
                  value: _vm.openedSettingsItem,
                  "save-changes": "",
                },
                on: {
                  close: function ($event) {
                    _vm.openedSettingsItem = null
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }